<template>
  <div>
    <h3 class="pb-3">
      <span v-if="settings.enable">
        Contactless is enabled for this Store
      </span>
      <span
        v-else
        class="error--text"
      >
        Contactless is not enabled for this Store
      </span>
    </h3>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="500px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          large
          color="success"
          class="elevation-0 ml-2"
          :loading="loader"
          disabled
        >
          Generate QR Codes
        </v-btn>

        <v-btn
          large
          color="success"
          class="elevation-0"
          v-bind="attrs"
          :loading="loader"
          v-on="on"
        >
          {{ settings.enable ? "Modify" : "Enable" }}
        </v-btn>
      </template>
      <v-card
        flat
        outlined
      >
        <v-card-title>
          Contactless
          <v-spacer />
          <v-btn
            icon
            @click="close()"
          >
            <v-icon color="error">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <form>
            <v-row>
              <v-col cols="12">
                <v-switch
                  v-model="form.enable"
                  inset
                  label="Enable"
                />
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-model="form.themeId"
                  clearable
                  label="Template"
                  placeholder="Choose Template"
                  :items="templates"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  v-model="form.enableSMSAuth"
                  clearable
                  label="Enable SMS Authentication"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            @click="close()"
          >
            Close
          </v-btn>
          <v-btn
            color="success"
            @click="save()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { failure } from "@/mixins/common";
export default {
  name: "ContactlessForm",
  mixins: [failure],
  props: {
    accountId: {
      type: Number,
      required: true
    },
    storeId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loader: false,
      dialog: false,
      templates: [],
      settings: {
        enable: false
      },
      form: {
        enable: false,
        themeId: null
      }
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        this.get();
      }
    }
  },
  created() {
    this.getTemplates();
    this.get();
  },
  methods: {
    getTemplates() {
      let url = `${this.ADMIN_API_URL}/accounts/${this.accountId}/contactless`;
      this.$http.get(url).then(
        (res) => {
          this.templates = res.body || [];
        },
        (failure) => {
          this.handleFailure(failure);
        }
      );
    },
    get() {
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/stores/${this.storeId}/contactless`;
      this.$http.get(url).then(
        (res) => {
          this.settings = res.body;
          this.form = JSON.parse(JSON.stringify(res.body));
          this.loader = false;
        },
        (failure) => {
          this.loader = false;
          this.handleFailure(failure);
        }
      );
    },
    save() {
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/stores/${this.storeId}/contactless`;
      this.$http.put(url, this.form).then(
        (res) => {
          this.loader = false;
          this.get();
          this.close();
          this.$store.commit("showSnackbar", {
            timeout: 3000,
            message: res.body.message
          });
        },
        (failure) => {
          this.loader = false;
          this.handleFailure(failure);
        }
      );
    },
    close() {
      this.dialog = false;
    }
  }
};
</script>